import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                  Отправить запрос на первой страницы постов
//------------------------------------------------------------------------------
export const getFirstPagePosts = async ({ signal } = {}) => {
  const url = `${backendUrl}/api/alpha/all/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    ...(signal ? { signal } : {}) // включаем signal только если он передан
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении первых постов: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения первых постов:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx